import React, { useEffect, useState } from "react";

// React Navigation
import {
  // useLocation,
  Link,
} from "react-router-dom";

// react lucide icon
import { Menu, X, ChevronDown } from "lucide-react";

// CSS styling
import "../styles/home.css";

// react responsive
import { useMediaQuery } from "react-responsive";

// Icons, Background, Card, and Logo
import ISAlogo from "../images/companyLogo/ISA-Logo.jpeg";
import ISAmobile from "../images/icons/ISA.png";
import DummyPerson from "../images/icons/dummyPerson.png";
import TwitterLogo from "../images/icons/TwitterLogo.png";
import FacebookLogo from "../images/icons/FacebookLogo.png";
import InstagramLogo from "../images/icons/InstagramLogo.png";
import LinkedInLogo from "../images/icons/LinkedInLogo.png";
import YoutubeLogo from "../images/icons/YoutubeLogo.png";

// Components
import ContainerText from "./Container";

const Header = () => {
  // const { pathname } = useLocation();

  const isMobileSize = useMediaQuery({ query: "(max-width: 640px)" });
  const isTabSize = useMediaQuery({
    query: "(min-width: 641px) and (max-width: 1210px)",
  });

  const [isOpenMobileNavbarMenu, setIsOpenMobileNavbarMenu] = useState(false);

  // const [burger, setBurger] = useState(false)

  // const changeBurgerColor = () => {
  //   if (pathname === "/") {
  //     if (window.scrollY >= 100) {
  //       document.getElementsByClassName("navigationMobile")[0].style.height =
  //         "100px";
  //       document.getElementsByClassName("navigationMobile")[0].style.height =
  //         "100px";
  //       document.getElementsByClassName(
  //         "bm-burger-bars"
  //       )[0].style.backgroundColor = "black";
  //       document.getElementsByClassName(
  //         "bm-burger-bars"
  //       )[1].style.backgroundColor = "black";
  //       document.getElementsByClassName(
  //         "bm-burger-bars"
  //       )[2].style.backgroundColor = "black";
  //     } else {
  //       document.getElementsByClassName("navigationMobile")[0].style.height =
  //         "0px";
  //       document.getElementsByClassName(
  //         "bm-burger-bars"
  //       )[0].style.backgroundColor = "black";
  //       document.getElementsByClassName(
  //         "bm-burger-bars"
  //       )[1].style.backgroundColor = "black";
  //       document.getElementsByClassName(
  //         "bm-burger-bars"
  //       )[2].style.backgroundColor = "black";
  //     }
  //   } else {
  //     document.getElementsByClassName("navigationMobile")[0].style.height =
  //       "100px";
  //     document.getElementsByClassName(
  //       "bm-burger-bars"
  //     )[0].style.backgroundColor = "black";
  //     document.getElementsByClassName(
  //       "bm-burger-bars"
  //     )[1].style.backgroundColor = "black";
  //     document.getElementsByClassName(
  //       "bm-burger-bars"
  //     )[2].style.backgroundColor = "black";
  //   }
  // };

  // useEffect(() => {
  //   changeBurgerColor();
  //   window.addEventListener("scroll", changeBurgerColor);
  // }, [pathname]);

  return (
    <header id="navigationBar">
      <div className="navigationBarMainContainer">
        {!isTabSize && !isMobileSize ? (
          <div className="navigationBarContainer bigScreen">
            <div className="navigationBarLogoContainer">
              <Link to="/">
                <img
                  className="navigationBarLogo"
                  src={ISAlogo}
                  alt="ISA - Institute for Sustainability and Agility"
                />
              </Link>
            </div>
            <div className="navigationBarMenuContainer navLink">
              <ul className="list-group list-group-horizontal">
                <div className="navigationBarAbout">
                  <li
                    className="list-group-item bg-transparent"
                    style={{ width: "7.5em" }}
                  >
                    <a href="#">About us</a>
                    <span className="angleDropdown">
                      <ChevronDown className="fas fa-angle-down" />
                    </span>
                  </li>
                  <div className="aboutUsList">
                    <ul className="list-group list-group-vertical border-0">
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem d-none"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/about/thefounder"
                        >
                          <p>Founder</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/about/company"
                        >
                          <p>Our Company</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/about/teammembers"
                        >
                          <p>Team Members</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/founders-story"
                        >
                          <p>Founder's Story</p>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="navigationBarAbout">
                  <li
                    className="list-group-item bg-transparent"
                    style={{ width: "10.5em" }}
                  >
                    <a href="#">ISA Consulting</a>
                    <span className="angleDropdown">
                      <ChevronDown className="fas fa-angle-down" />
                    </span>
                  </li>
                  <div className="aboutUsList">
                    <ul className="list-group list-group-vertical border-0">
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/expertise/esg"
                        >
                          <p>ESG</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/expertise/esg-audit"
                        >
                          <p>ESG Audit</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/expertise/csr"
                        >
                          <p>CSR</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/expertise/sustainability-report"
                        >
                          <p>Sustainability Report</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/expertise/policy-analysis"
                        >
                          <p>Policy Analysis</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/expertise/policy-writing"
                        >
                          <p>Policy Writing</p>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* <div className="navigationBarAbout">
                  <li
                    className="list-group-item bg-transparent"
                    style={{ width: "10.5em" }}
                  >
                    <a href="#">ISA Academy</a>
                    <span className="angleDropdown">
                      <ChevronDown className="fas fa-angle-down" />
                    </span>
                  </li>
                  <div className="aboutUsList">
                    <ul className="list-group list-group-vertical border-0">
                      <li
                        className="list-group-item bg-transparent border-0"
                        onClick={() => navigate(`/diploma-pm-for-esg`)}
                        style={{
                          display: "flex",
                          justifyContent: "left",
                        }}
                      >
                        <p>Diploma PM for ESG</p>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0"
                        onClick={() => navigate(`/academy`)}
                        style={{ justifyContent: "left" }}
                      >
                        <p>Webinars and workshops</p>
                      </li>
                    </ul>
                  </div>
                </div> */}
                <li className="list-group-item bg-transparent">
                  <a
                    href="https://isaacademy.co.id/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ISA Academy
                  </a>
                </li>
                <div className="navigationBarAbout">
                  <li
                    className="list-group-item bg-transparent"
                    style={{ width: "9.5em" }}
                  >
                    <a href="#">Our Media</a>
                    <span className="angleDropdown">
                      <ChevronDown className="fas fa-angle-down" />
                    </span>
                  </li>
                  <div className="aboutUsList">
                    <ul className="list-group list-group-vertical border-0">
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/activities"
                        >
                          <p>Activities</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/blog"
                        >
                          <p>Articles</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/books"
                        >
                          <p>Books & Infographics</p>
                        </Link>
                      </li>
                      <li
                        className="list-group-item bg-transparent border-0 navigationBarLinkItem"
                      >
                        <Link
                          className="navigationBarLinkFill"
                          to="/learning-videos"
                        >
                          <p>Learning Videos</p>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <li
                  className="list-group-item bg-transparent"
                  style={{ width: "15em" }}
                >
                  <a
                    href="https://www.cloudxier.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    IT Consultancy Services
                  </a>
                </li>
                <li
                  className="list-group-item bg-transparent navigationBarLinkItem"
                  style={{ width: "9.5em" }}
                >
                  <Link
                    className="navigationBarLinkFill"
                    to="/clients"
                  >
                    Our Clients
                  </Link>
                </li>
                <li className="list-group-item bg-transparent d-none">
                  Resources
                </li>
                <li
                  className="list-group-item bg-transparent navigationBarLinkItem"
                  style={{ width: "9.5em" }}
                >
                  <Link
                    className="navigationBarLinkFill"
                    to="/contact"
                  >
                    Contact us
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div className="navigationBarLoginContainer d-none">
              <ul className="list-group list-group-horizontal">
                <li className="list-group-item bg-transparent border-0">
                  <i className="navigationBarSearch" />
                </li>
                <li className="list-group-item bg-transparent border-0">
                  <img
                    className="navigationBarDummy"
                    src={DummyPerson}
                    alt="dummy"
                  />
                </li>
                <div className="navigationBarLogin">
                  <li className="list-group-item bg-transparent border-0">
                    Login
                  </li>
                </div>
              </ul>
            </div> */}
          </div>
        ) : null}
        <div className="fullWidthNavbarFollowUsOnSocialMedia">
          <div className="navbarFollowUsOnSocialMediaContainer">
            <div className="navbarFollowUsOnSocialMediaImgContainer">
              <a
                href="https://twitter.com/isa_company"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={TwitterLogo} alt="Twitter" />
              </a>
              <a
                href="https://www.facebook.com/isa.sustainability"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={FacebookLogo} alt="Facebook" />
              </a>
              <a
                href="https://www.instagram.com/isa.sustainability"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={InstagramLogo} alt="Instagram" />
              </a>
              <a
                href="https://www.linkedin.com/company/institute-for-sustainability-and-agility/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={LinkedInLogo} alt="LinkedIn" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCWsQCHf9PodPl-_V_GaYorg/featured"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={YoutubeLogo} alt="YouTube" />
              </a>
            </div>
          </div>
        </div>
        {isMobileSize || isTabSize ? (
          <div className="navigationMobile">
            <div>
              <Link to="/">
                <img
                  src={isMobileSize ? ISAmobile : ISAlogo}
                  alt="ISA - Institute for Sustainability and Agility"
                  style={{
                    width: isMobileSize ? "60px" : "300px",
                    height: "auto",
                  }}
                />
              </Link>
            </div>
            {!isOpenMobileNavbarMenu ? (
              <Menu
                onClick={() => setIsOpenMobileNavbarMenu(true)}
                style={{ width: "40px", height: "40px" }}
              />
            ) : (
              <div className="menuContainer">
                <X
                  style={{ width: "25px", height: "25px", color: "white" }}
                  onClick={() => setIsOpenMobileNavbarMenu(false)}
                />
                <Link
                  className="menu-item mobileMainMenuStyle"
                  to="/"
                >
                  Home
                </Link>
                {/* <div
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                >
                  About us
                </div> */}
                <Link
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                  to="/about/company"
                >
                  Our company
                </Link>
                <Link
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                  to="/about/teammembers"
                >
                  Team Members
                </Link>
                <Link
                  className="menu-item mobileMainMenuStyle"
                  to="/founders-story"
                >
                  Founder's Story
                </Link>
                <div
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "5px" }}
                >
                  Expertise
                </div>
                <Link
                  to="/expertise/esg"
                  onClick={() => setIsOpenMobileNavbarMenu(false)}
                  style={{ marginBottom: "0" }}
                >
                  ESG
                </Link>
                <Link
                  to="/expertise/esg-audit"
                  onClick={() => setIsOpenMobileNavbarMenu(false)}
                  style={{ marginBottom: "0" }}
                >
                  ESG Audit
                </Link>
                <Link
                  to="/expertise/csr"
                  onClick={() => setIsOpenMobileNavbarMenu(false)}
                  style={{ marginBottom: "0" }}
                >
                  CSR
                </Link>
                <Link
                  to="/expertise/sustainability-report"
                  onClick={() => setIsOpenMobileNavbarMenu(false)}
                  style={{ marginBottom: "0" }}
                >
                  Sustainability Report
                </Link>
                <Link
                  to="/expertise/policy-analysis"
                  onClick={() => setIsOpenMobileNavbarMenu(false)}
                  style={{ marginBottom: "0" }}
                >
                  Policy Analysis
                </Link>
                <Link
                  to="/expertise/policy-writing"
                  onClick={() => setIsOpenMobileNavbarMenu(false)}
                  style={{ marginBottom: "0" }}
                >
                  Policy Writing
                </Link>
                {/* <div
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                >
                  ISA Academy
                </div> */}
                <a
                  style={{ marginTop: "1em" }}
                  className="menu-item mobileMainMenuStyle"
                  href="https://isaacademy.co.id/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ISA Academy
                </a>
                {/* <div
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                  onClick={() => navigate(`/diploma-pm-for-esg`)}
                >
                  Diploma PM for ESG
                </div>
                <div
                  className="menu-item mobileMainMenuStyle"
                  onClick={() => navigate(`/academy`)}
                >
                  Webinars and workshops
                </div> */}
                {/* <div
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                >
                  Our Media
                </div> */}
                <Link
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                  to="/activities"
                >
                  Activities
                </Link>
                <Link
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                  to="/blog"
                >
                  Articles
                </Link>
                <Link
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                  to="/books"
                >
                  Books
                </Link>
                <Link
                  className="menu-item mobileMainMenuStyle"
                  style={{ marginBottom: "10px" }}
                  to="/learning-videos"
                >
                  Learning Videos
                </Link>
                <Link
                  className="menu-item mobileMainMenuStyle"
                  to="/diploma-pm-for-esg"
                >
                  infographics
                </Link>
                <a
                  className="menu-item mobileMainMenuStyle"
                  href="https://www.cloudxier.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  IT Consultancy Services
                </a>
                <Link
                  className="menu-item mobileMainMenuStyle"
                  to="/clients"
                >
                  Our Clients
                </Link>
                <Link
                  className="menu-item mobileMainMenuStyle"
                  to="/contact"
                >
                  Contact us
                </Link>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </header>
  );
};

export default Header;
